import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Pet from '../../components/Global/Pet';
import GoodyBag from '../../components/Extension/GoodyBag';
import PetPicker from '../../components/Extension/PetPicker';
import Snapshot from '../../components/Extension/Snapshot';
import ShopBox from '../../components/Extension/ShopBox';
import Background from '../../components/Global/Background';

import getKitten from '../../utils/getKitten';
import { setKitten } from '../../actions/activePet';
import { updateInAppPurchaseData } from '../../actions/googleApi';
import { MINS_TO_VERIFY_GOOGLE } from '../../constants';

class Extension extends React.Component {
	componentWillMount() {
		this.shouldSetKitten();
		this.shouldCheckGooglePayments();
	}

	shouldCheckGooglePayments() {
		this.props.updateInAppPurchaseData();

		// Local storage contains a verification timestamp that we
		// used to check google if the extension was loaded after
		// MINS_TO_VERIFY_GOOGLE (2) minutes. This is to prevent
		// people from cheating by "buying" pets using localstorage.
		// We are no longer using the timestamp.

		// const now = moment();
		// const then = moment(this.props.lastVerification.date);
		// const minsSinceLastCheck = now.diff(then, 'minutes');

		// if (
		// 	!this.props.lastVerification.date || // If there's no verification date
		// 	minsSinceLastCheck > MINS_TO_VERIFY_GOOGLE || // or we've surpassed the time to check again
		// 	minsSinceLastCheck < 0 || // or if it's in the future
		// 	this.props.allPets.length <= 1 || // or if the allPets store doesn't have more than the cat
		// 	this.props.lastVerification.error // or there was an API error.
		// ) {
		// 	this.props.updateInAppPurchaseData();
		// }
	}

	shouldSetKitten() {
		const thisKitten = getKitten(this.props.pet);
		if (thisKitten) {
			this.props.setKitten(thisKitten);
		}
	}

	render() {
		return (
			<Background {...this.props.pet}>
				<Pet {...this.props.pet} />
				<ShopBox />
				<GoodyBag />
				<Snapshot />
				<PetPicker />
			</Background>
		);
	}
}

const mapStateToProps = state => ({
	lastVerification: state.lastVerification,
	allPets: state.allPets,
	pet: {
		...state.activePet.active,
		glasses: state.activeGoodies.active.glasses,
		hat: state.activeGoodies.active.hat,
		toy: state.activeGoodies.active.toy,
	},
});

const mapDispatchToProps = dispatch => ({
	setKitten: (kitten) => {
		dispatch(setKitten(kitten));
	},
	updateInAppPurchaseData: () => {
		dispatch(updateInAppPurchaseData());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Extension);



// WEBPACK FOOTER //
// ./src/routes/Extension/index.js